/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q3Inputs */

const en_diff_faq_q3 = /** @type {(inputs: Diff_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are array differences detected?`)
};

const ko_diff_faq_q3 = /** @type {(inputs: Diff_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 차이는 어떻게 감지되나요?`)
};

const ja_diff_faq_q3 = /** @type {(inputs: Diff_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の差分はどのように検出されますか？`)
};

/**
* | output |
* | --- |
* | "How are array differences detected?" |
*
* @param {Diff_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q3 = /** @type {((inputs?: Diff_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q3(inputs)
	if (locale === "ko") return ko_diff_faq_q3(inputs)
	return ja_diff_faq_q3(inputs)
});